/*! Digital Ummah — instant data layer (Digital X).
 * Loaded synchronously BEFORE the page content so the page's own fetch() calls to ummahapi.com
 * are answered from a persistent, versioned, size-capped localStorage cache (stale-while-revalidate).
 * Cached answers resolve in the same task, so widgets render before the first paint — no spinners.
 *  - static data (duas, 99 names, names): served from cache, refreshed in the background when old
 *  - day-bound data (Hijri date, prayer times, events, Ramadan): keyed by date, never served for the wrong day
 *  - "random verse": a small pool of pre-fetched verses makes "New verse" instant
 *  - zakat: computed locally (identical maths to the API) when prices are given; otherwise the API is used
 * Exposes window.dxuCache = { prefetch(urls), prefetchVerses(), has(url), stats() }.
 */
(function () {
  "use strict";
  if (window.dxuCache || !window.fetch || !window.Promise) return;
  var NS = "dxuc:v1:", IDX = NS + "idx", CAP = 1200000, API = "https://ummahapi.com/api/";
  var ls = null;
  try { ls = window.localStorage; var k = NS + "t"; ls.setItem(k, "1"); ls.removeItem(k); } catch (e) { ls = null; }
  var nativeFetch = window.fetch.bind(window);
  var H = 3600e3, D = 24 * H;

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function localDay() { var d = new Date(); return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()); }
  function utcDay() { var d = new Date(); return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()); }
  function hourSlot(n) { return utcDay() + "T" + Math.floor(new Date().getUTCHours() / n); }

  // day: a key that must match for the entry to be served; ttl: age after which we refresh in the background
  var RULES = [
    { re: /\/api\/today-hijri$/, day: utcDay, ttl: 30 * 60e3 },
    { re: /\/api\/moon$/, day: function () { return hourSlot(3); }, ttl: 30 * 60e3 },
    { re: /\/api\/prayer-times\?/, day: localDay, ttl: 6 * H },
    { re: /\/api\/ramadan\?/, day: localDay, ttl: 6 * H },
    { re: /\/api\/islamic-events$/, day: utcDay, ttl: 6 * H },
    { re: /\/api\/qibla\?/, ttl: 30 * D },
    { re: /\/api\/duas$/, ttl: 2 * D, fanout: function (j) {
        // one request primes all 27 category caches (same shape as /api/duas/category/{id})
        var cats = (j.data && j.data.categories) || [], all = (j.data && j.data.duas) || [], cr = RULES[7];
        cats.forEach(function (c) {
          var list = all.filter(function (d) { return d.category === c.id; });
          if (!list.length) return;
          var u = API + "duas/category/" + c.id;
          if (!valid(read(u), cr)) write(u, cr, JSON.stringify({ success: true, service: "duas-category", data: { category: { id: c.id, name: c.name, description: c.description }, total: list.length, duas: list } }));
        });
      }, slim: function (j) { return { success: j.success, data: { categories: (j.data && j.data.categories) || [] } }; } },
    { re: /\/api\/duas\/category\//, ttl: 2 * D },
    { re: /\/api\/asma-ul-husna$/, ttl: 7 * D },
    { re: /\/api\/names\/\d+$/, ttl: 7 * D }
  ];
  function ruleFor(url) { for (var i = 0; i < RULES.length; i++) if (RULES[i].re.test(url)) return RULES[i]; return null; }
  function clean(j) { if (j && typeof j === "object") { delete j.api_info; delete j.timestamp; } return j; }

  /* ---------------- storage with LRU size cap */
  var idx = {};
  try { idx = JSON.parse(ls && ls.getItem(IDX) || "{}") || {}; } catch (e) { idx = {}; }
  var idxT = 0;
  function saveIdx() { if (!ls || idxT) return; idxT = setTimeout(function () { idxT = 0; try { ls.setItem(IDX, JSON.stringify(idx)); } catch (e) {} }, 300); }
  function total() { var s = 0; for (var k in idx) s += idx[k][1]; return s; }
  function evict(need) {
    var keys = Object.keys(idx).sort(function (a, b) { return idx[a][0] - idx[b][0]; });
    while (keys.length && total() + need > CAP) { var k = keys.shift(); try { ls.removeItem(k); } catch (e) {} delete idx[k]; }
  }
  function read(url) {
    if (!ls) return null;
    try { var raw = ls.getItem(NS + url); if (!raw) return null; var e = JSON.parse(raw); if (idx[NS + url]) { idx[NS + url][0] = Date.now(); saveIdx(); } return e; } catch (e2) { return null; }
  }
  function write(url, rule, text) {
    if (!ls) return;
    var e = { t: Date.now(), d: rule && rule.day ? rule.day() : "", b: text }, s = JSON.stringify(e), key = NS + url;
    if (s.length > CAP / 4) return;
    delete idx[key]; evict(s.length);
    for (var tries = 0; tries < 3; tries++) {
      try { ls.setItem(key, s); idx[key] = [Date.now(), s.length]; saveIdx(); return; } catch (err) { evict(s.length + 200000); }
    }
  }
  function valid(e, rule) { return e && (!rule.day || e.d === rule.day()); }

  /* ---------------- network with in-flight de-duplication */
  var inflight = {};
  function net(url, rule) {
    if (inflight[url]) return inflight[url];
    var p = nativeFetch(url, { credentials: "omit" }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    }).then(function (j) {
      if (!j || j.success === false) throw new Error("bad payload");
      if (rule && rule.fanout) { try { rule.fanout(j); } catch (e) {} }
      j = clean(rule && rule.slim ? rule.slim(j) : j);
      var text = JSON.stringify(j);
      if (rule) write(url, rule, text);
      return text;
    });
    inflight[url] = p;
    p.then(function () { delete inflight[url]; }, function () { delete inflight[url]; });
    return p;
  }
  function respond(text, src) {
    var r = new Response(text, { status: 200, headers: { "Content-Type": "application/json", "X-Dxu-Cache": src } });
    try { Object.defineProperty(r, "json", { value: function () { return Promise.resolve(JSON.parse(text)); } }); } catch (e) {}
    return r;
  }

  /* ---------------- random-verse pool */
  var VKEY = NS + "vpool", VURL = API + "quran/random", vfill = null;
  function vpool() { try { return JSON.parse(ls && ls.getItem(VKEY) || "[]") || []; } catch (e) { return []; } }
  function vsave(p) { try { ls && ls.setItem(VKEY, JSON.stringify(p.slice(0, 6))); } catch (e) {} }
  function fillVerses(n) {
    if (!ls || vfill) return vfill || Promise.resolve();
    n = n || 4;
    var p = vpool(), need = Math.max(0, n - p.length), jobs = [];
    for (var i = 0; i < need; i++) jobs.push(nativeFetch(VURL + "?_=" + Date.now() + i, { credentials: "omit" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (j && j.success !== false) { var q = vpool(); var s = JSON.stringify(clean(j)); if (q.indexOf(s) < 0) { q.push(s); vsave(q); } }
    }).catch(function () {}));
    vfill = Promise.all(jobs).then(function () { vfill = null; });
    return vfill;
  }

  /* ---------------- local zakat (same maths as /api/zakat/calculate) */
  function round2(n) { return Math.round(n * 100) / 100; }
  function zakat(b) {
    var gp = +b.gold_price_per_gram || 0, sp = +b.silver_price_per_gram || 0;
    if (!(gp > 0 && sp > 0)) return null; // the API auto-fills live prices — let it
    var gv = round2((+b.gold_grams || 0) * gp), sv = round2((+b.silver_grams || 0) * sp);
    var gross = round2((+b.cash || 0) + gv + sv + (+b.stocks || 0) + (+b.business_goods || 0) + (+b.other_investments || 0));
    var liab = +b.liabilities || 0, netw = Math.max(0, round2(gross - liab));
    var silver = b.nisab_standard !== "gold", nis = round2(silver ? 595 * sp : 85 * gp), above = netw >= nis && netw > 0;
    var due = above ? round2(netw * 0.025) : 0;
    return { success: true, service: "zakat-calculate", data: { zakat_due: due, zakat_due_formatted: due.toFixed(2), above_nisab: above, nisab_standard: silver ? "silver" : "gold", nisab_value: nis, nisab_gold_grams: 85, nisab_silver_grams: 595, rate: "2.5%",
      breakdown: { cash: +b.cash || 0, gold_value: gv, silver_value: sv, stocks: +b.stocks || 0, business_goods: +b.business_goods || 0, other_investments: +b.other_investments || 0, gross_wealth: gross, liabilities: liab, net_zakatable_wealth: netw } } };
  }

  /* ---------------- fetch wrapper (only ummahapi.com) */
  var stats = { hit: 0, miss: 0, stale: 0, local: 0 };
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var method = ((init && init.method) || (input && input.method) || "GET").toUpperCase();
    if (url.indexOf(API) !== 0) return nativeFetch(input, init);
    if (method === "POST" && /\/zakat\/calculate$/.test(url)) {
      try { var z = zakat(JSON.parse(init.body)); if (z) { stats.local++; return Promise.resolve(respond(JSON.stringify(z), "local")); } } catch (e) {}
      return nativeFetch(input, init);
    }
    if (method !== "GET") return nativeFetch(input, init);
    if (url === VURL) {
      var pool = vpool();
      if (pool.length) { var first = pool.shift(); vsave(pool); stats.hit++; setTimeout(function () { fillVerses(4); }, 50); return Promise.resolve(respond(first, "pool")); }
      setTimeout(function () { fillVerses(4); }, 1500);
      return nativeFetch(input, init);
    }
    var rule = ruleFor(url);
    if (!rule || !ls) return nativeFetch(input, init);
    var e = read(url);
    if (valid(e, rule)) {
      stats.hit++;
      if (Date.now() - e.t > rule.ttl) setTimeout(function () { net(url, rule).catch(function () {}); }, 1200); // revalidate quietly
      return Promise.resolve(respond(e.b, "hit"));
    }
    stats.miss++;
    return net(url, rule).then(function (text) { return respond(text, "net"); }, function (err) {
      if (e && !rule.day) { stats.stale++; return respond(e.b, "stale"); } // offline: static data is still good
      throw err;
    });
  };

  /* ---------------- prefetch API for the interface layer */
  var queue = [], running = 0;
  function pump() {
    while (running < 3 && queue.length) {
      var u = queue.shift(), r = ruleFor(u);
      if (!r) continue;
      var e = read(u);
      if (valid(e, r) && Date.now() - e.t < r.ttl) continue;
      running++;
      net(u, r).catch(function () {}).then(function () { running--; pump(); });
    }
  }
  window.dxuCache = {
    prefetch: function (urls) { (urls || []).forEach(function (u) { if (queue.indexOf(u) < 0 && !inflight[u]) queue.push(u); }); pump(); },
    prefetchVerses: function () { return fillVerses(4); },
    has: function (u) { var r = ruleFor(u); return !!(r && valid(read(u), r)); },
    stats: function () { return { hits: stats.hit, misses: stats.miss, stale: stats.stale, local: stats.local, bytes: total(), entries: Object.keys(idx).length, verses: vpool().length }; }
  };
})();
